<template>
    <div id="chargeDetail">
        <!--<div style="border: 1px solid red">-->
        <p class="chargeDetai_p">抓药详情</p>
        <div style="display: flex">
            <div class="infomation">
                <div class="Headpic"><img :src="this.patientBaseEntity.image" ></div>
                <div class="name">{{this.patientBaseEntity.name}}</div>
                <div class="in-table">
                    <div class="in-tabOne"><h2>性别:<span>{{this.patientBaseEntity.gender}}</span></h2></div>
                    <div class="in-tabTow"><h2>周岁:<span>{{this.patientBaseEntity.age}}</span></h2></div>
                </div>
                <div class="in-tel"><h2>电话:<span>{{this.patientBaseEntity.mobileNumber}}</span></h2></div>
                <div class="in-tel"><h2>订单状态:<span>{{this.medicineInfo.orderStatusName}}</span></h2></div>
                <div class="in-tel"><h2>抓药时间:<span>{{this.medicineInfo.getMedicineDateTime}}</span></h2></div>
                <!--</div>-->
            </div>

            <div class="list">
                <div class="list_p">详情</div>
                <el-collapse v-model="activeNames" @change="handleChange">
                    <el-collapse-item v-for="(item,index) in tablevalue"
                                      :title="item.recipeName + '、'+item.quantity+'副、'+item.eatType"
                                      :key="item.id" :name="index" style="text-indent: 10px" >
                        <template>
                            <el-table :data="item.recipeItemResponseList" style="width: 100%" border  :header-cell-style="tableHeaderColor">
                                <el-table-column prop="medicineName" label="药品名称"></el-table-column>
                                <el-table-column prop="medicineNumber" label="数量" width="150"></el-table-column>
                                <el-table-column prop="stockNumber" label="当前库存" width="150"></el-table-column>
                                <el-table-column label="历史余量" width="150">
                                    <template slot-scope="{row}">
                                        {{[2, 5].includes(status) ? row.residualNumber :''}}
                                    </template>
                                </el-table-column>
<!--                                <el-table-column prop="residualNumber" label="历史余量" width="150"></el-table-column>-->
                                <el-table-column prop="medicineUnit" label="单位" width="150"></el-table-column>
                            </el-table>
                        </template>
                        <!--<div>-->
                            <!--&nbsp;&nbsp;副&nbsp;&nbsp;数：-->
                            <!--<el-input :class="{input:active}" v-model="item.quantity"-->
                                      <!--:disabled="true"></el-input>-->
                        <!--</div>-->
                        <!--<div>-->
                            <!--&nbsp;&nbsp;煎服法：-->
                            <!--<el-input type="textarea" :class="{input2:active}" v-model="item.eatType"-->
                                      <!--autosize-->
                                      <!--:disabled="true"></el-input>-->
                        <!--</div>-->
                        <div>
                            &nbsp;&nbsp;忌口及日常护理：
                            <el-input type="textarea" :class="{input1:active}" v-model="item.note" autosize
                                      :disabled="true"></el-input>
                        </div>
                    </el-collapse-item>
                </el-collapse>



                <div v-show="status==4">
                    &nbsp;&nbsp;邮寄地址：
                    <el-input type="textarea" :class="{input3:active}" v-model="this.medicineInfo.mailAddress" autosize
                              :disabled="true"></el-input>
                </div>
                <div v-show="status==5">
                    &nbsp;&nbsp;邮寄地址：
                    <el-input type="textarea" :class="{input3:active}" v-model="this.medicineInfo.mailAddress" autosize
                              :disabled="true"></el-input>
                </div>
                <div class="button" v-if="this.$route.query.data">
                    <el-button type="primary" @click="confirm" v-show="status==1">确认抓药</el-button>
                    <el-button type="primary" @click="send" v-show="status==4">确认邮寄</el-button>
                    <router-link to="./medicine_list">
                        <el-button type="info" plain>取消</el-button>
                    </router-link>
                </div>
                <div class="button" v-if="this.$route.query.Data">
                    <router-link to="./medicine_list">
                        <el-button type="info" plain>返回</el-button>
                    </router-link>
                </div>
            </div>

        </div>
    </div>
</template>
<style type="text/css" scoped>
    .el-button--primary {
        color: #fff;
        background-color:  rgb(60, 110, 169);
        border-color: rgb(60, 110, 169);
    }
    .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
        color: #fff;
        background-color: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
    }
    .el-button--primary:focus, .el-button--primary:hover {
        background: rgba(60, 110, 169, 0.65);
        border-color: rgba(60, 110, 169, 0.65);
        color: #fff;
    }
    .el-collapse-item__header.is-active{
        color: #3a3a3a;
        font-size: 17px;
    }
    .el-collapse-item__header{
        color:#3a3a3a;
        font-size: 17px;
        background-color: rgba(0, 0, 0, 0.09);
        border-bottom: 1px solid #ccd0d7;
    }

    .Headpic{
        width: 100px;
        height: 100px;
        margin-top: 8px;
        margin-left: 35%;
        border-bottom: 1px solid #e7e7e7;
        border-radius: 50%;
        overflow: hidden;
    }
    .Headpic img{
        width: 100%;
        height: 100%;
    }
    .input {
        width: 34%;
        padding-top: 10px;
        padding-bottom: 5px;
        margin-left: 69px;
    }
    .input1 {
        width: 34%;
        padding-top: 10px;
        margin-left: 20px;
    }
    .input3{
        width: 34%;
        padding-top: 10px;
        margin-left: 48px;
    }
    .input2 {
        width: 34%;;
        margin-left: 72px;
    }

    .button {
        margin-top: 20px;
        padding-left: 40%;
    }

    #chargeDetail {
        width: 99%;
        padding-bottom: 50px;
        background-color: white;
        /*margin: 30px 20px;*/
        display: inline-block;
    }

    .chargeDetai_p {
        width: 100%;
        border-bottom: 1px solid #e7e7e7;
        font-size: 20px;
        /*color: #0B7509;*/
        height: 50px;
        line-height: 50px;
    }

    .infomation {
        width: 20%;
        height: 365px;
        border: 1px solid #dcdcdc;
        margin: 20px 15px;
        box-shadow: 0 0 10px #dcdcdc;
        border-radius: 10px;
    }

    .name {
        margin-top: 20px;
        padding-bottom: 30px;
        border-bottom: 1px solid #dcdcdc;
        text-align: center;
    }

    .in-table {
        height: 45px;
        text-align: left;
        border-bottom: 1px solid #dcdcdc;
    }

    .in-table div {
        line-height: 45px;
        width: 48%;
        display: inline-block;
    }

    .in-tabOne {
        border-right: 1px solid #dcdcdc;
    }

    .in-tabOne h2 {
        font-weight: inherit;
        padding-left: 13px;
        color: #dcdcdc;
        margin: 0;
        font-size: 16px;
        display: inline-block;
    }

    .in-tabTow h2 {
        font-weight: inherit;
        padding-left: 13px;
        color: #dcdcdc;
        margin: 0;
        font-size: 16px;
        display: inline-block;
    }

    .in-tabOne h2 span {
        margin-left: 8px;
        color: black;
    }

    .in-tabTow h2 span {
        margin-left: 8px;
        color: black;
    }

    .in-tel {
        height: 45px;
        text-align: left;
        border-bottom: 1px solid #dcdcdc;
    }

    .in-tel h2 {
        line-height: 45px;
    }

    .in-tel h2 {
        font-weight: inherit;
        padding-left: 13px;
        color: #dcdcdc;
        margin: 0;
        font-size: 16px;
        display: inline-block;
    }

    .in-tel h2 span {
        margin-left: 8px;
        color: black;
    }

    .list {
        width: 70%;
        padding-bottom: 30px;
        border: 1px solid #dcdcdc;
        box-shadow: 0 0 10px #dcdcdc;
        border-radius: 10px;
        flex-wrap: nowrap;
        margin-top: 20px;
        margin-left: 50px;
    }

    .list_p {
        text-indent: 5px;
        border-bottom: 1px solid #dcdcdc;
        height: 60px;
        width: 100%;
        line-height: 60px;
        font-size: 20px;
        color: #a4a7af;
        background-color: #f2f2f2;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;

    }

    .zufang {
        padding-left: 5px;
        color: rgba(0, 0, 0, 0.68);
        width: 100%;
        height: 55px;
        padding-top: 20px;
    }
</style>
<script>
  export default {
    data() {
      return {
        activeNames: 0,
        much: '3',
        tablevalue: [],
        active: true,
        queryData: '',
          phone:'',
        Index:[],
        medicineInfo: {},
        patientBaseEntity:{},
          status:''
      }
    },
    mounted: function () {
        if (this.$route.query.data) {
        let data = JSON.parse(this.$route.query.data);
        this.queryData =data.orderNumber;
        this.status = data.status;
        }

        if (this.$route.query.Data) {
        let Data = JSON.parse(this.$route.query.Data);
            this.lookid= Data.orderNumber;
            this.queryData =Data.orderNumber;
             this.status = Data.status;
        }


      this.getinfo();
    },
    methods: {
      handleChange(val) {
      },
      tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        if (rowIndex === 0) {
          return "color: black;text-indent:4px";
        }
      },
      getinfo: function () {
        this.$axios({
          url: '/api/order/' + this.queryData,
          method: 'GET'
        }).then(res => {
          this.patientBaseEntity = res.data.data.patientBaseEntity
          this.medicineInfo = res.data.data;
          this.tablevalue = res.data.data.recipeResponseList;
          // let datalist = res.data.data.recipeResponseList;
          // for (let k=0;k<datalist.length;k++){
          //   datalist[k].Index= '汤方'+[k+1];
          //   this.tablevalue.push(datalist[k]) ;
          // }

        }).catch(err => {
          console.log(err.data);
        })
      },
      confirm: function () {
          if (this.status ==1){
        this.$axios({
          url: '/api/order/takeTheMedicine/' + this.queryData,
          method: 'GET',
          showLoading: false
        }).then(res => {
          if (res.data.code == 200) {
            this.$message({
              type: 'success',
              message: '抓药成功'
            })
            this.$router.push({path: "./medicine_list"})
          } else {
            this.$message({
              type: 'success',
              message: '抓药失败'
            })
          }
          // this.sendSmsAdvise();
        }).catch(err => {
          console.log(err.data);
        })
          }
      },
        //邮寄确认接口
        send:function (){
          if (this.status==4) {
            this.$axios({
                url: '/api/order/mailTheMedicine/' + this.queryData,
                method: 'GET'
            }).then(res => {
                if (res.data.code == 200) {
                    this.$message({
                        type: 'success',
                        message: '邮寄成功'
                    })
                    this.$router.push({path: "./medicine_list"})
                } else {
                    this.$message({
                        type: 'success',
                        message: '邮寄失败'
                    })
                }
                // this.sendSmsAdvise();
            }).catch(err => {
                console.log(err.data);
            })
          }
        },
        //抓药成功后短信发送医嘱接口
      sendSmsAdvise: function () {
        let data = {
          "phone": this.patientBaseEntity.mobileNumber,
          "jianfufa": this.medicineInfo.eatType,
          "richanghuli": this.medicineInfo.note
        };
        this.$axios({
          url: '/api/sys/smslog/sendSmsAdvise',
          method: 'POST',
          data: data
        }).then(res => {
        }).catch(err => {
          console.log(err.data);
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// medicineDetail.vue?650401ec